import { useRouter } from 'next/navigation'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'base-ui'

import {
  CONTACT_FORM_SUBJECT_KEY,
  DirectContactFormDialogWrapper,
  directContactFormSubjectCatalogGetValue,
} from '../../../../direct-contact'
import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetContactUs } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutOtherTopicsCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const config = useGlobalConfigContext()
  const modalControlsFormDialog = useOpenableControls()
  const intl = useIntl()
  const router = useRouter()

  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  return (
    <>
      <Button
        color="secondary"
        data-qa-id="qa-id-other-topics"
        onClick={(): void => {
          modalControlsFormDialog.handleOpen()
        }}
        size="small"
      >
        <FormattedMessage id="help.centre.others.options.title" />
      </Button>
      <DirectContactFormDialogWrapper
        disableSubject
        formSubject={directContactFormSubjectCatalogGetValue(
          intl,
          CONTACT_FORM_SUBJECT_KEY.OTHER_CONCERN,
        )}
        modalControls={modalControlsFormDialog}
        onSuccessClose={() => {
          router.replace(
            urlResolverGetContactUs(config, {
              queryParams: { target: 'order-details-other-topics' },
            }),
          )
        }}
        prefilledSubOrder={subOrder}
      />
    </>
  )
}
